import { render, staticRenderFns } from "./DataListProjets.vue?vue&type=template&id=9c2f6c10&"
import script from "./DataListProjets.vue?vue&type=script&lang=js&"
export * from "./DataListProjets.vue?vue&type=script&lang=js&"
import style0 from "./DataListProjets.vue?vue&type=style&index=0&id=9c2f6c10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports